import { SagaIterator } from "redux-saga";
import { call, delay, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setBadges, setLoading } from "../../repository/slice";

function* getBadgesWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/badge/admin/list", payload);
        if (isError) {

        } else {
            yield put(setBadges(data.rows));
        }
    } catch (error) {
        console.error("getBadgesWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getBadgesWatcher() {
    yield takeLatest("@saga/GET_BADGES", getBadgesWorker);
};